import { Breadcrumb, Layout, Tabs } from "antd"
import { FailedRenewalsBoundary } from "./boundary"
import { LayoutPageContent, LayoutPageHeader } from "components"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import {
  Route,
  RouteComponentProps,
  Switch,
  useHistory
} from "react-router-dom"
import { StaticContext } from "react-router"
import { FailedAutobindRenewals } from "./views/FailedAutobindRenewals"
import { FailedRenewalInvitations } from "./views/FailedRenewalInvitations"
import { RenewalsPendingManualReview } from "./views/RenewalsPendingManualReview"

type Props = RouteComponentProps<
  {
    id: string
    subpage: string
  },
  StaticContext,
  {
    data?: string
  }
>

export const FailedRenewals: React.FC<Props> = (props) => {
  const history = useHistory()

  const onTabClick = (activeKey: string) => {
    switch (activeKey) {
      case "autobound":
        history.push(`/failed-renewals`)
        break
      case "invitations":
        history.push(`/failed-renewals/invitations`)
        break
      case "review":
        history.push(`/failed-renewals/review`)
        break
    }
  }

  return (
    <FailedRenewalsBoundary>
      <Layout>
        <LayoutPageHeader
          ghost={false}
          breadcrumb={
            <Breadcrumb>
              <Breadcrumb.Item key="/failed-renewals">
                <ExclamationCircleOutlined />
                &nbsp;Failed Renewals
              </Breadcrumb.Item>
            </Breadcrumb>
          }
          title="Failed Renewals"
          footer={
            <Tabs
              onTabClick={onTabClick}
              defaultActiveKey={props.match.params.subpage}
              activeKey={props.match.params.subpage}
            >
              <Tabs.TabPane
                tab="Failed Autobind Renewals"
                key="autobound"
              ></Tabs.TabPane>
              <Tabs.TabPane
                tab="Failed Renewal Invitations"
                key="invitations"
              ></Tabs.TabPane>
              <Tabs.TabPane
                tab="Pending Manual Review"
                key="review"
              ></Tabs.TabPane>
            </Tabs>
          }
        />
        <LayoutPageContent transparent>
          <Switch>
            <Route
              exact
              path={`/failed-renewals`}
              render={() => <FailedAutobindRenewals />}
            ></Route>
            <Route
              path={`/failed-renewals/autobound`}
              render={() => <FailedAutobindRenewals />}
            ></Route>
            <Route
              path={`/failed-renewals/invitations`}
              render={() => <FailedRenewalInvitations />}
            ></Route>
            <Route
              path={`/failed-renewals/review`}
              render={() => <RenewalsPendingManualReview />}
            ></Route>
          </Switch>
        </LayoutPageContent>
      </Layout>
    </FailedRenewalsBoundary>
  )
}
